import { Trans } from "@lingui/react/macro";
import { cn } from "@/utils";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@heroui/react";
import { LimeDatePicker } from "@/Components/NextBase/LimeDatePicker";
import { UseFormReturnType } from "@mantine/form";
import { POSForm } from "./POS";
import { t } from "@lingui/core/macro";
import useFeature from "@/hooks/useFeature";

export const ExtraMenuModal = ({
  isOpen,
  handleClose,
  canCreateInvoice,
  isLoading,
  handlePickCustomer,
  handleSplitPayment,
  hideCreateEstimate,
  form,
  isEstimatePopoverOpen,
  setIsEstimatePopoverOpen,
}: {
  isOpen: boolean;
  handleClose: () => void;

  canCreateInvoice: boolean;
  hideCreateEstimate: boolean;

  isLoading: boolean;

  handlePickCustomer: () => void;
  handleSplitPayment: () => void;
  form: UseFormReturnType<POSForm>;
  isEstimatePopoverOpen: boolean;
  setIsEstimatePopoverOpen: (open: boolean) => void;
}) => {
  return (
    <>
      <Modal
        size="xl"
        isOpen={isOpen}
        onClose={handleClose}
        classNames={{
          closeButton: "m-2",
        }}
      >
        <ModalContent>
          {(_) => (
            <>
              <ModalHeader>
                <Trans>Dodatna dejanja</Trans>
              </ModalHeader>
              <ModalBody className="gap-2 px-2">
                <ExtraMenuButtons
                  canCreateInvoice={canCreateInvoice}
                  isLoading={isLoading}
                  handlePickCustomer={handlePickCustomer}
                  handleSplitPayment={handleSplitPayment}
                  hideCreateEstimate={hideCreateEstimate}
                  form={form}
                  isEstimatePopoverOpen={isEstimatePopoverOpen}
                  setIsEstimatePopoverOpen={setIsEstimatePopoverOpen}
                />
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export const ExtraMenuButtons = ({
  canCreateInvoice,
  hideCreateEstimate,
  isLoading,
  handlePickCustomer,
  handleSplitPayment,
  className,
  form,
  isEstimatePopoverOpen,
  setIsEstimatePopoverOpen,
}: {
  canCreateInvoice: boolean;
  hideCreateEstimate: boolean;
  isLoading: boolean;
  handlePickCustomer: () => void;
  handleSplitPayment: () => void;
  className?: string;
  form: UseFormReturnType<POSForm>;
  isEstimatePopoverOpen: boolean;
  setIsEstimatePopoverOpen: (open: boolean) => void;
}) => {
  const { isFeatureEnabled } = useFeature();

  return (
    <>
      <Button
        className={cn("h-12", className)}
        onPress={handlePickCustomer}
        data-identifier="open-assign-customer"
      >
        <Trans>Dodeli stranko</Trans>
      </Button>
      <Button
        className={cn("h-12", className)}
        onPress={handleSplitPayment}
        isDisabled={!canCreateInvoice}
        color="primary"
        data-identifier="open-split-payment"
      >
        <Trans>Razdeli plačilo</Trans>
      </Button>
      {hideCreateEstimate ||
      !isFeatureEnabled("TAX_REGISTER_ESTIMATES") ? null : (
        <Popover
          showArrow
          backdrop="opaque"
          isOpen={isEstimatePopoverOpen}
          onOpenChange={setIsEstimatePopoverOpen}
        >
          <PopoverTrigger>
            <Button
              className={cn("h-12", className)}
              type="button"
              isDisabled={!canCreateInvoice}
              isLoading={isLoading}
              color="primary"
              data-identifier="issue-estimate-popover"
            >
              <Trans>Predračun</Trans>
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            <div className="flex min-w-80 flex-col gap-2 px-1 py-2">
              <LimeDatePicker
                label={t`Rok plačila`}
                className="mt-2"
                data-identifier="due-date-picker"
                {...form.getInputProps("dateDue")}
              />

              <Button
                form="pos-form"
                type="submit"
                isDisabled={!canCreateInvoice}
                isLoading={isLoading}
                value={"estimate"}
                color="primary"
                data-identifier="issue-estimate"
              >
                <Trans>Ustvari predračun</Trans>
              </Button>
            </div>
          </PopoverContent>
        </Popover>
      )}
    </>
  );
};
